<template>
    <Head title="Informations de contact" />

    <SettingsLayout :contact-settings="contactSettings">
        <div class="bg-white shadow-lg sm:rounded-md border border-gray-200 my-3 p-4">
            <form class="grid grid-cols-6 gap-4">
                <!-- address -->
                <div class="col-span-6">
                    <JetLabel for="address" value="Adresse postale:" />
                    <JetInput
                        type="text"
                        id="address"
                        autocomplete="off"
                        v-model="form.address"
                        placeholder="Entrer l'adresse postale"
                    />
                    <JetInputError :message="form.errors.address" />
                </div>
                <!-- email -->
                <div class="col-span-2">
                    <JetLabel for="email" value="Adresse mail:" />
                    <JetInput id="email" type="email" v-model="form.email"
                        placeholder="Entrer l'adresse mail"  autocomplete="off"
                    />
                    <JetInputError :message="form.errors.email" />
                </div>
                <!-- numberPhone -->
                <div class="col-span-2">
                    <JetLabel for="phone" value="Numéro de téléphone:" />
                    <vue-tel-input required @input="phoneInput"
                        :defaultCountry="form.country_code" :value="form.phone"
                    />
                    <JetInputError :message="form.errors.phone" />
                </div>
                <div class="col-span-2">
                    <JetLabel for="wa_phone" value="Numéro WhatsApp:" />
                    <vue-tel-input required @input="waPhoneInput"
                        :defaultCountry="form.wa_country_code" :value="form.wa_phone"
                    />
                    <JetInputError :message="form.errors.wa_phone" />
                </div>
                <!-- facebook -->
                <div class="col-span-3">
                    <JetLabel for="facebook_link" value="Lien facebook:" />
                    <JetInput
                        id="facebook_link"
                        v-model="form.facebook_link"
                        type="text"
                        autocomplete="off"
                        placeholder="Entrer le lien facebook"
                    />
                    <JetInputError :message="form.errors.facebook_link" />
                </div>
                <!-- linkedin -->
                <div class="col-span-3">
                    <JetLabel for="linkedin_link" value="Lien linkedin:" />
                    <JetInput
                        id="linkedin_link"
                        v-model="form.linkedin_link"
                        type="text"
                        autocomplete="off"
                        placeholder="Entrer le lien linkedin"
                    />
                    <JetInputError :message="form.errors.linkedin_link" />
                </div>
                <div class="col-span-6 flex items-center justify-end py-3 bg-gray-50 text-right sm:px-2 shadow sm:rounded-bl-md sm:rounded-br-md">
                    <boti-button :loader="form.processing" :disabled="form.processing"
                        @click="updateContactSettingInformation()"  class="w-full" color="sky"
                        :class="{ 'opacity-25': form.processing }" text="Mettre à jour"
                    >
                        <i v-if="form.processing" class="fad fa-pencil text-sm"></i>
                        <template #icon>
                            <i class="fad fa-check-circle text-xs ml-1"></i>
                        </template>
                    </boti-button>
                </div>
            </form>
        </div>
    </SettingsLayout>
</template>

<script>
    import JetInput from '@/Jetstream/Input.vue';
    import JetLabel from '@/Jetstream/Label.vue';
    import { Head } from '@inertiajs/inertia-vue3';
    import BotiButton from '@/Components/Button.vue';
    import JetInputError from '@/Jetstream/InputError.vue';
    import JetFormSection from '@/Jetstream/FormSection.vue';
    import SettingsLayout from '@/Layouts/SettingsLayout.vue';
    import RebuildPhoneMixins from '@/Mixins/RebuildPhoneMixins'
    import JetActionMessage from '@/Jetstream/ActionMessage.vue';
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';

    export default {
        props: {
            contactSettings: Object
        },

        mixins: [RebuildPhoneMixins],

        components: {
            Head,
            JetLabel,
            JetInput,
            BotiButton,
            JetInputError,
            JetFormSection,
            SettingsLayout,
            JetActionMessage,
            JetActionMessage,
            JetSecondaryButton
        },
        data() {
            return {
                form: this.$inertia.form({
                    address: this.contactSettings.address,
                    email: this.contactSettings.email,
                    phone: this.contactSettings.phone,
                    dial_code: this.contactSettings.dial_code,
                    country_code: this.contactSettings.country_code,
                    wa_phone: this.contactSettings.wa_phone,
                    wa_dial_code: this.contactSettings.wa_dial_code,
                    wa_country_code: this.contactSettings.wa_country_code,
                    facebook_link: this.contactSettings.facebook_link,
                    linkedin_link: this.contactSettings.linkedin_link,
                })
            }
        },

        methods: {
            updateContactSettingInformation() {

                this.form.put(route('settings.update.contact'), {
                    preserveScroll: true,
                    onSuccess: () =>{
                        this.$swal.fire(
                            'Informations de contact',
                            'Informations de contacts mises à jour avec succès.',
                            'success'
                        )
                    },
                });
            },

        }
    }
</script>
